module.exports = __webpack_public_path__ + "img/ghosty.1dfa4f1b.gif";